import { Directive, OnDestroy, OnInit } from '@angular/core';
import { ColumnAlignment, ColumnVisibility, TableKind, TableMode, TableViewKind } from '../definitions/table.definitions';
import { BaseViewComponent } from './base-view.component';

@Directive()
export abstract class TableBaseViewComponent extends BaseViewComponent implements OnInit, OnDestroy {
    readonly TableKind = TableKind;
    readonly TableMode = TableMode;
    readonly TableViewKind = TableViewKind;
    readonly ColumnAlignment = ColumnAlignment;
    readonly ColumnVisibility = ColumnVisibility;

    private _isTableInitialized: boolean = false;

    TableInit(): void {
        this._isTableInitialized = true;
    }

    get isTableInitialized(): boolean {
        return this._isTableInitialized;
    }

    set isTableInitialized(value: boolean) {
        this._isTableInitialized = value;
    }

    abstract CallFetchData(): void
}
